import {
  additionalEquipmentCostService,
  categoryService,
  contractEquipmentService,
  contractLineService,
  contractService,
  costElementService,
  equipmentService,
  examService,
  laboratoryService,
  macroExamService,
  productService,
  workstationService
} from 'shared/services';
import { labelThresholdService } from 'features/inventory/warehouses/api/label-threshold.service';
import { supplierService } from 'features/inventory/suppliers/api/SupplierService';
import { sectorService } from 'features/settings/topology/api/sector.service';
import { operationalUnitService } from 'features/settings/topology/api/operational-unit.service';
import { productWarehouseService } from 'features/inventory/warehouses/api/product-warehouse.service';
import { warehouseService } from 'features/inventory/warehouses/api/warehouse.service';

export const contractsApi = {
  services: {
    contractService,
    contractLineService,
    contractEquipmentService,
    additionalEquipmentCostService
  },
  getContract: (contractId: number) => contractService.get(contractId),
  updateContract: (contractId: number, payload: unknown) =>
    contractService.update(contractId, payload),
  createContract: (payload: unknown) => contractService.add(payload as any),
  assignContractLines: (contractId: number, lines: unknown[]) =>
    contractService.assignProducts(lines as any, contractId),
  deleteContractLine: (lineId: number) => contractLineService.delete(lineId),
  updateContractLine: (lineId: number, payload: unknown) =>
    contractLineService.update(lineId, payload),
  addContractEquipment: (payload: unknown) => contractEquipmentService.add(payload as any),
  updateContractEquipment: (id: number, payload: unknown) =>
    contractEquipmentService.update(id, payload),
  deleteContractEquipment: (id: number) => contractEquipmentService.delete(id),
  addAdditionalCost: (payload: unknown) => additionalEquipmentCostService.add(payload as any),
  deleteAdditionalCost: (id: number) => additionalEquipmentCostService.delete(id),
  getCategoryOptions: () => categoryService.getAllBaseInformation(),
  getEquipmentBase: () => equipmentService.getAllBaseInformation(),
  getProductBase: () => productService.getAllBaseInformation(),
  getWarehouseBase: () => warehouseService.getAllBaseInformation(),
  getSupplierBase: () => supplierService.getAllBaseInformation(),
  getLaboratoryBase: () => laboratoryService.getAllBaseInformation(),
  getProductWarehouseOptions: () => productWarehouseService.options(),
  getLabelThresholds: () => labelThresholdService.getAllPaginated(),
  getCostLayerTypes: () => costElementService.getLayerOptions(),
  getLayerOptionsByModel: (model: string) => {
    switch (model) {
      case 'laboratory':
        return laboratoryService.getAllBaseInformation();
      case 'operationalunit':
        return operationalUnitService.getAllBaseInformation();
      case 'sector':
        return sectorService.getAllBaseInformation();
      case 'workstation':
        return workstationService.getAllBaseInformation();
      case 'equipment':
        return equipmentService.getAllBaseInformation();
      case 'exam':
        return examService.getAllBaseInformation();
      case 'macroexam':
        return macroExamService.getAllBaseInformation();
      default:
        return Promise.resolve([]);
    }
  },
  getProductWarehouseByProductAndWarehouse: (productId: number, warehouseId: number) =>
    productWarehouseService.getAllPaginated(1000, 0, {
      product_id: productId,
      warehouse_id: warehouseId
    }),
  addProductWarehouseThreshold: (payload: unknown) => productWarehouseService.add(payload as any)
};
